import { z } from 'zod/v3'

const baseBenchmarksSearchSchema = z.object({
	/** The benchmark the edit dialog targets — in the URL, so the dialog is deep-linkable. */
	benchmarkId: z.coerce.number().int().positive().optional(),
})

// Create/edit dialog state. The edit dialog targets the selected `benchmarkId`, so the `edit`
// branch needs no id of its own.
const dialogSearchStateSchema = z.union([
	z.object({ dialog: z.literal('create') }),
	z.object({ dialog: z.literal('edit') }),
	z.object({ dialog: z.undefined().optional() }),
])

export const benchmarksSearchSchema = baseBenchmarksSearchSchema.and(dialogSearchStateSchema)

export type BenchmarksSearch = z.infer<typeof benchmarksSearchSchema>
